<template>
  <GestionPilares />
</template>
<script>
import GestionPilares from "./components/GestionPilares";
export default {
  components: { GestionPilares },
  created(){
    if (!this.$store.getters["auth/isLogged"]) {
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    isLogged() {
      return this.$store.getters["auth/isLogged"]
        ? this.$store.getters["auth/isLogged"]
        : false;
    },
  }
};
</script>